module.exports = __webpack_public_path__ + "static/media/RevCover.f1a7f4a6.png";